import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { logPatientWire } from '../debug/logPatientWire';
import { patientsApi } from '../api/patientsApi';

export function usePatientForms(id: number | null | undefined, enabled = true) {
  return useQuery({
    queryKey: keys.patientForms(id ?? 0),
    queryFn: async ({ signal }) => {
      const data = await patientsApi.getForms(id!, { signal });
      logPatientWire(`GET /api/patients/${id}/forms`, data);
      return data;
    },
    enabled: id != null && enabled,
    staleTime: 60_000,
  });
}
